export default __webpack_public_path__ + "img/69ab3511a104a3954247f970413dd7bf.svg";